const CANCELLATION_POLICY_DEFAULT_BLOCKS = [
  {
    id: "default-cancellation-policy",
    type: "policy-document",
    fields: {
      icon: "CalendarCheck",
      eyebrow: "Support",
      title: "Cancellation Policy",
      dateline: "",
      intro:
        "This page explains how to cancel an Exqura booking and how refunds work. Cancellation terms can vary by service provider; the policy that applies to your booking is shown before you confirm it.",
      sections: [
        {
          title: "1. Cancelling Your Booking",
          body: "You can cancel a confirmed booking from My Bookings up to 24 hours before the booking date.\nOnline cancellation is not available within 24 hours of the booking date. For urgent help, please contact our team.",
        },
        {
          title: "2. Refunds",
          body: "Approved refunds are processed to the original payment method within 7–14 business days, subject to the service provider's policy.",
        },
        {
          title: "3. Changes Made by Exqura or a Provider",
          body: "In the rare event that Exqura or a service provider must cancel a confirmed booking, we will notify you promptly and offer a full refund or alternative arrangement.",
        },
        {
          title: "4. Contact Us",
          body: "Questions about a cancellation? Email support@exqura.com.",
        },
      ],
    },
  },
];

export default CANCELLATION_POLICY_DEFAULT_BLOCKS;
